import React from 'react';
import cx from 'classnames';
import styles from './sharing-modal-button.module.scss';

const SharingModalButton = ({ children, onClick, clicked, disabled = false }) => {
  return (
    <button
      className={cx(styles.button, [clicked && styles.clicked], [disabled && styles.disabled])}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={styles.text}>{children}</span>
    </button>
  );
};

export default SharingModalButton;
